// TODO: move backend types to constants and import from there

import { DeviceType as DeviceTypeMap } from '@adalo/constants'

export type DeviceType = typeof DeviceTypeMap[keyof typeof DeviceTypeMap]

export interface Attributes {
  name: string
  variableHeight: boolean
  zIndex: number
  width: number
  height: number
  y: number
  x: number
  borderWidth?: number
  updatedPosition?: {
    x: number
    y: number
  }
}

export interface RunnerObject {
  shared: {
    [DeviceTypeMap.MOBILE]: boolean
    [DeviceTypeMap.TABLET]: boolean
    [DeviceTypeMap.DESKTOP]: boolean
  }
  id: string
  attributes: Attributes
  type: string
  children: RunnerObject[]
  layout: Layout
  positioning: string
  responsivity?: {
    horizontalPositioning: string
    verticalPositioning: string
    horizontalScaling: string
    verticalScaling: string
  }
}

export type TransformValue = { translateX: number } | { translateY: number }

export interface Layout {
  width?: string | number
  height?: string | number
  left?: string | number
  top?: number | string
  bottom?: string | number
  right?: string | number
  marginLeft?: string | number
  marginTop?: string | number
  marginBottom?: string | number
  position?: 'absolute' | 'relative'
  transform?: TransformValue[]
  zIndex?: number
  overflow?: 'hidden' | 'visible'
}

export interface Screen {
  id: string
  height: number
  statusBarStyle: string
}

export enum ComponentFixedPosition {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}
